import { parseHtmlString } from "@/utils/helpers/html";
import { Heading, Paragraph } from "@/components/ui/Typography"
import { WebsitePageSection } from "@/types"
import EditableSection from "@/components/admin/Content/WebPages/EditableSection";
import InlineMultimediaVideoEditor from "@/components/admin/Content/WebPages/InlineEditors/InlineMultimediaVideoEditor";
import { useHomePageHighlights } from "@/lib/api/hooks/video";
import { Video } from "@/lib/api/types";

// Helper function to format date
const formatPublishedDate = (dateString: string | null): string => {
  if (!dateString) return '';
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch {
    return '';
  }
};

const MultimediaVideos = ({ data }: { data: WebsitePageSection }) => {
  // Fetch live highlights
  const { data: highlightsData } = useHomePageHighlights('HOME_PAGE_IS_MULTIMEDIA');
  const highlightedVideos = highlightsData?.data || [];

  return (
    <EditableSection
      sectionTag={data.sectionTag}
      contentType={data.contentType}
      data={data}
      customEditor={InlineMultimediaVideoEditor}
    >
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <Paragraph className="bg-gray-50 rounded-2xl px-3 py-1 !text-sm flex items-center justify-center text-forestGreen-100 w-fit">Videos</Paragraph>
          <div className="flex items-center gap-6">
            <Heading level={4} >{data.title ?? "Multimedia Videos"}</Heading>
          </div>
          <Paragraph dangerouslySetInnerHTML={parseHtmlString(data.description ?? "Explore our latest videos.")} />
        </div>

        {/* Live Preview of Highlights */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {highlightedVideos.length > 0 ? (
            highlightedVideos.map((video: Video) => (
              <div key={video.videoUploadId} className="border border-gray-100 rounded-lg overflow-hidden shadow-sm">
                <div className="h-32 bg-gray-100 relative">
                  <img
                    src="https://res.cloudinary.com/dlwegkhme/image/upload/v1755760288/Image-11_sxxnhn.png"
                    alt={video.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-3">
                  <h5 className="font-medium text-sm line-clamp-1">{video.title}</h5>
                  {video.datePublished && (
                    <p className="text-xs text-gray-500 mt-1"><span className="font-medium">Published date:</span> {formatPublishedDate(video.datePublished)}</p>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="col-span-2 text-center py-4 text-gray-400 text-sm border-2 border-dashed border-gray-100 rounded-lg">
              No highlights selected. Click to add.
            </div>
          )}
        </div>
      </div>
    </EditableSection>
  )
}

export default MultimediaVideos